import { render, staticRenderFns } from "./TaskSafeItem.vue?vue&type=template&id=77938d10&scoped=true&"
import script from "./TaskSafeItem.vue?vue&type=script&lang=js&"
export * from "./TaskSafeItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskSafeItem.vue?vue&type=style&index=0&id=77938d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77938d10",
  null
  
)

export default component.exports